<template>
	<b-container id="main-content">
		<b-card
			header-tag="header"
			header-bg-variant="light"
			style="min-width: 15rem; max-width: 45rem;"
		>
			<div slot="header" class="text-dark">
				<div class="bigger"><b>Complete</b></div>
			</div>
			<p class="card-text">
				Thank you. Your application has been submitted for review.
			</p>
		</b-card>
		<div class="mt-3">
			<b-btn
				class="float-center"
				variant="secondary"
				size="sm"
				@click.prevent="close_action()"
			>
				Close
			</b-btn>
		</div>
	</b-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	computed: {
		...mapGetters(["userType"])
	},
	methods: {
		close_action() {
			this.$store.commit("set_application_status", null);
			this.$store.commit("set_active_application", null);

			this.$store.commit("clear_alerts");

			if (this.userType === "guest") {
				this.$router.push("/intro");
			} else {
				this.$router.push("/applications");
			}
		}
	}
};
</script>

<style scoped>
div.bigger {
	font-size: larger;
}
</style>
